// extracted by mini-css-extract-plugin
module.exports = {"my_bonus":"MyBonus_my_bonus__fRUAG"};